<template>
  <div class="gk-footer">
    <div class="container">
      <div class="row">
        <div class="col-md-4">
          <ul class="gk-footer-menu">
            <li>
              <p class="title">Alamat</p>
              <p>Jl. Brigjen Katamso No. 1 Wonosari, Gunungkidul (55813)</p>
            </li>
            <li>
              <p class="title">Telepon</p>
              <p>(0274) 391259</p>
            </li>
            <li>
              <p class="title">Faksimile</p>
              <p>(0274) 391259</p>
            </li>
            <li>
              <p class="title">Email</p>
              <p>humas@gunungkidulkab.go.id</p>
            </li>
          </ul>
        </div>
        <div class="col-md-8">
          <ul class="gk-footer-menu">
            <li>
              <p class="title">MAKLUMAT PELAYANAN INFORMASI PUBLIK</p>
              <p>
                Kami berupaya memberikan Pelayanan Pengelola Informasi Dan Dokumentasi dengan sungguh-sungguh untuk dapat memberikan pelayanan informasi yang cepat dan tepat waktu, memberikan kemudahan dalam mendapatkan informasi publik yang diperlukan dengan murah dan sederhana, menyediakan dan memberikan informasi publik yang akurat, benar dan tidak menyesatkan, menyediakan daftar informasi publik untuk informasi yang wajib disediakan dan diumumkan, menyediakan daftar informasi publik dan fasilitas pelayanan sesuai dengan ketentuan dan tata tertib yang berlaku, menyiapkan ruang dan fasilitas yang nyaman dan tertata baik, merespon dengan cepat permintaan informasi dan keberatan atas informasi publik yang disampaikan baik langsung maupun media, menyiapkan petugas informasi yang berdedikasi dan siap melayani, dan
melakukan pengawasan internal dan evaluasi kinerja pelaksana.
              </p>
            </li>
          </ul>
          <ul class="gk-sosmed">
            <li>
              <a href="https://www.facebook.com/gunungkidulkab/" class="sosmed-circle" data-toggle="tooltip" title="Facebook" target="_blank">
                <i class="fab fa-facebook"></i>
              </a>
            </li>
            <li>
              <a href="https://twitter.com/pemkabgk" class="sosmed-circle" data-toggle="tooltip" title="Twitter" target="_blank">
                <i class="fab fa-twitter"></i>
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/pemkabgunungkidul/" class="sosmed-circle" data-toggle="tooltip" title="Instagram" target="_blank">
                <i class="fab fa-instagram"></i>
              </a>
            </li>
            <li>
              <a href="https://www.youtube.com/channel/UCh_2fNk90hsRL8up5IjccGg" class="sosmed-circle" data-toggle="tooltip" title="Youtube" target="_blank">
                <i class="fab fa-youtube"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="gk-footer-foot">
      <div class="container">
        <span>Pemkab Gunungkidul &copy; 2020</span> | <a href="https://ppid.gunungkidulkab.go.id/privacy_policy">Privacy</a>
      </div>
    </div>
  </div>
</template>

<script>
  import 'bootstrap';

  export default{
    data() {
      return {

      }
    },
    mounted() {
      $('[data-toggle="tooltip"]').tooltip();
    }
  }
</script>

<style scoped lang="scss">
  @import '../../../../../../app/assets/stylesheets/abstracts/variables';

  .gk-footer {
    background: $footer;
    padding: 30px 0 20px;
    color: $footer-text;
  }

  .gk-footer-menu {
    list-style-type: none;
    margin: 0 0 20px;
    padding: 0;

    .title {
      margin-bottom: 4px;
      font-family: 'Roboto', sans-serif;
      font-size: 14px;
      font-weight: 500;
      color: $secondary;
    }

    p {
      margin-bottom: 10px;
      font-size: 13px;
      line-height: 20px;
    }
  }

  .gk-sosmed {
    display: flex;
    align-items: center;
    margin: 0 0 20px;
    padding: 0;
    list-style-type: none;

    .sosmed-circle {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
      width: 30px;
      height: 30px;
      font-size: 16px;
      color: $footer-text;
      text-align: center;
      border: 1px solid #fff;
      border-radius: 50%;

      &:hover {
        background: #fff;
        color: $footer;
      }
    }
  }

  .gk-footer-foot {
    padding-top: 20px;
    border-top: 1px solid rgba(255, 255, 255, .6);
    font-size: 12px;
  }
</style>